export const factoriesList = [
	{
		type: 0,
		produce: "fe",
		name: "Iron Mine",
		rates: [50, 100],
		price: 500,
	},
	{
		type: 1,
		produce: "al",
		name: "Aluminium Quarry",
		rates: [25, 50],
		price: 800,
	},
	{
		type: 2,
		produce: "cu",
		name: "Copper Well",
		rates: [10, 20],
		price: 1000,
	},
	{
		type: 3,
		produce: "au",
		name: "Gold Mine",
		rates: [5, 10],
		price: 1200,
	},
	{
		type: 4,
		produce: "ti",
		name: "Titanium Quarry",
		rates: [2, 5],
		price: 1500,
	},
];
